import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Toogle from "../toggle";
import { DescriptionField, IconButton } from "components/support";

const IntegrationsList = ({ integrations, presenter, handleEdit }) =>
  integrations.map((integration, index) => (
    <Row key={index}>
      <Col xs={10}>
        <DescriptionField label="Token" value={integration.token} />
        <DescriptionField
          label="Organização"
          value={integration.organization_name}
        />
        <DescriptionField label="Estoque" value={integration.stock_name} />
        <DescriptionField
          label="Canal de Venda"
          value={integration.sale_channel_name}
        />
      </Col>
      <Col xs={1}>
        <Toogle
          data={integration}
          onChangeEnabled={() => presenter.onSaveEnabled(integration)}
        />
      </Col>
      <Col xs={1}>
        <IconButton icon="mode_edit" onClick={() => handleEdit(integration)} />
      </Col>
    </Row>
  ));

export default IntegrationsList;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/integrations-list/IntegrationsList.jsx